<template>
    <div>
        <!--emitNodeId($event)-->
        <div class="biggerWrapper">
            <div class="bigWrapper" v-bind:class="{isOpen: showTable, hidden: unregisteredNb < 1}">
                <input id="tableToggle" type="checkbox" name="tableToggle" />
                <label for="tableToggle" class="unregisteredNumber" v-bind:class="{pressed: showTable }" @click="openTable()" v-if="!showTable">
                    {{unregisteredNb}}
                </label>
                <label for="tableToggle" class="closeLabel" @click="openTable()" v-if="showTable">
                    <font-awesome-icon icon="times" class="closeIcon"></font-awesome-icon>
                </label>
                <div class="tableWrapper overflow-auto" v-show="showTable">
                    <b-table id="unregisteredTable"
                             class="table"
                             fixed
                             striped
                             hover
                             sticky-header
                             :items="filtered"
                             :fields="unregisteredMarkersCol"
                             :per-page="perPage"
                             :current-page="currentPage"
                             primary-key="Index">
                        <template slot="top-row" slot-scope="{ fields }">
                            <td v-for="field in fields" :key="field.key">
                                <input v-model="filters[field.key]" :placeholder="field.label">
                            </td>
                        </template>
                        <template v-slot:cell()="row">
                            <div :draggable="adminAccess" @dragstart="emitDragItem(row.item, $event)">{{ row.value }}</div>
                        </template>
                    </b-table>
                    <b-pagination aria-controls="unregisteredTable"
                                  v-model="currentPage"
                                  :per-page="perPage"
                                  :total-rows="rows"
                                  size="sm"
                                  align="center"
                                  limit="3"
                                  >
                    </b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faTimes } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import poly from '@/types/map/type-poly';

    library.add(faTimes);

    @Component({
        components: {
            FontAwesomeIcon,
        }
    })

    export default class UnregisteredMarker extends Vue {

        @Prop() private unregisteredNb!: string;
        @Prop() private unregisteredMarkers!: poly[];
        @Prop() private showTable!: boolean;
        @Prop() private adminAccess!: boolean;

        unregisteredMarkersCol?: object[] = [{ label: this.$t('Name').toString(), key: "Name" }, { label: this.$t('Invariant').toString(), key: "Invariant" }];

        perPage: number = 26;
        currentPage: number = 1;

        filters: object = {
            Name: '',
            Invariant: '',
        }
        get rows() {
            return this.filtered.length
        }
        get filtered() {
            const filtered = this.unregisteredMarkers.filter(item => {
                return Object.keys(this.filters).every(key =>
                    String(item[key]).includes(this.filters[key]))
            })
            return filtered.length > 0 ? filtered : [{
                Name: '',
                Invariant: '',
            }]
        }
        openTable() {
            if (this.unregisteredMarkers.length != 0) {
                this.$emit('emitShowTable');
            }
        }
        emitNodeId(item: poly) {
            this.$emit('emitNodeId', item);
            console.log(item);
            console.log(this.rows);
        }
        emitDragItem(item: poly, event: any) {
            var img = document.createElement('img');
            img.src = this.getIcon(item)
            event.dataTransfer.setDragImage(img, 0, 30)
            this.$emit('emitDragItem', item);
        }
        getIcon(item: poly) {
            var icon;
            icon = require(`@/assets/images/mapicons/${item.ObjectType}_Map_Icon.png`);
            return icon
        }
    }
</script>

<style scoped>

    .biggerWrapper {
        position: absolute;
        overflow: hidden;
        left: 0;
        bottom: 0;
        height: 363px;
        width: 300px;
        transition: all .3s;
    }

    .bigWrapper {
        position: absolute;
        bottom: -75px;
        left: -75px;
        overflow: hidden;
        height: 150px;
        width: 150px;
        z-index: 4;
        border-radius: 100%;
        background-color: #7b9c23;
        transition: all 0.6s;
    }

    .isOpen {
        height: 525px;
        width: 525px;
    }

    .tableWrapper {
        position: inherit;
        overflow-x: auto;
        width: auto;
        z-index: 5;
        background-color: white !important;
        bottom: 75px;
        left: 75px;
        user-select: none;
    }

    .table {
        background-color: white;
        font-size: xx-small;
        width: 300px;
        height: 367px;
        scrollbar-width: thin;
    }

    .unregisteredNumber {
        position: inherit;
        display: inline-block;
        margin: 0;
        bottom: 90px;
        left: 90px;
        text-align: center;
        cursor: pointer;
        user-select: none;
        z-index: 6;
        transition: all .6s;
    }

    .pressed {
        color: #7b9c23;
        bottom: 85px;
        left: 90px;
    }

    .closeLabel {
        position: inherit;
        display: flex;
        height: 25px;
        width: 25px;
        bottom: 85px;
        left: 95px;
        text-align: center;
        cursor: pointer;
        user-select: none;
        z-index: 6;
        transition: all .3s;
        background-color: #7b9c23;
        border-radius: 100%;
    }

    .closeIcon {
        margin: auto;
    }

    #tableToggle {
        display: none;
    }

    .hidden {
        transform: translate(-50px, 50px);
    }
</style>

<style>

</style>